'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  config: {
    useMinimalHeader: true
  },
  contentLoggedOut: {
    minimalHeader: {
      labelMenuButton: 'Menu',
      labelClose: 'Close',
      logo: {
        text: 'PayPal',
        href: '/webapps/mpp/home'
      },
      headerButtons: [{
        id: 'ul-btn',
        text: 'Log In',
        href: '/signin?country.x=US&locale.x=en_US'
      }, {
        id: 'signup-button',
        text: 'Sign Up',
        href: '/webapps/mpp/account-selection',
        color: 'white'
      }]
    }
  },
  contentLoggedIn: {
    minimalHeader: {
      labelMenuButton: 'Menu',
      labelClose: 'Close',
      logo: {
        text: 'PayPal',
        href: '/webapps/mpp/home'
      },
      headerButtons: [{
        id: 'myaccount-button',
        text: 'My PayPal',
        href: '/signin'
      }, {
        id: 'logout-button',
        text: 'Log out',
        href: '/signout'
      }]
    }
  }
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/minimal-header/jsx/MPPMinimalHeaderDefaultProps.js
// module id = 1119
// module chunks = 4